import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.39 1.62a.75.75 0 0 0-.74 0l-3.56 1.86-3.82-1.86h-.06a.85.85 0 0 0-.35-.08.52.52 0 0 0-.18 0l-.19.08-3.85 2a.75.75 0 0 0-.4.67v9.42a.75.75 0 0 0 .36.64.7.7 0 0 0 .39.11.73.73 0 0 0 .35-.09l3.55-1.87 3.89 1.89a.28.28 0 0 0 .13 0 .69.69 0 0 0 .2 0 .82.82 0 0 0 .39-.11l3.85-2a.75.75 0 0 0 .4-.66V2.26a.76.76 0 0 0-.36-.64Zm-9.26 9.61L2.74 12.5V4.77l2.39-1.26Zm4.23 1.32-2.73-1.33V3.46l2.73 1.33Zm3.89-1.32-2.39 1.27V4.77l2.39-1.26Z';
const draw24px =
  'M21.35,3a.76.76,0,0,0-.73,0L15.14,5.91,9.23,3,9.17,3h0A.28.28,0,0,0,9,3a.52.52,0,0,0-.17,0,.64.64,0,0,0-.2,0,.3.3,0,0,0-.15,0L2.67,6.09a.77.77,0,0,0-.4.67V20.84a.77.77,0,0,0,.75.75.73.73,0,0,0,.35-.09l5.48-2.89,5.92,2.87.1.05h0a.69.69,0,0,0,.24.05.8.8,0,0,0,.42-.13l5.75-3a.75.75,0,0,0,.4-.66V3.69A.76.76,0,0,0,21.35,3ZM8.09,17.31,3.77,19.59V7.21L8.09,4.93ZM9.59,4.89,14.4,7.23v12.4L9.59,17.29ZM20.22,17.31,15.9,19.59V7.21l4.32-2.28Zm-5.45,4.17.05,0,0,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const MapIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'map'),
) as IconWithRender;

MapIcon.displayName = 'MapIcon';
MapIcon.propTypes = Icon.propTypes;
MapIcon.renderIcon = (props) => <MapIcon {...props} />;
export default MapIcon;
